import { dataService } from '@app/modules/data';
import { DataObject, ObjectOptions } from './base';

import { Place } from './place';

export interface _PlaceBlock {
    status: string;
    place: number;
    block_start: string;
    block_end: string;
    reason: string;
}

interface _PlaceBlockData extends _PlaceBlock {
    objid?: number;
    _uuid?: string;
    created?: Date;
    updated?: Date;
}

abstract class PlaceBlockData extends DataObject {
    protected _block: _PlaceBlockData = {
        status: null,
        place: null,
        block_start: null,
        block_end: null,
        reason: null
    };

    constructor(table: string, objid: string, data: dataService, objoptions: ObjectOptions) {
        super(table, objid, data, objoptions);
        this._block.created = new Date();
        this._block.updated = new Date();
    }

    get created() { return this._block.created; }
    get updated() { return this._block.updated; }

    get place(): Place {
        return this._children['place'] || null;
    }

    set place(value: Place) {
        if (this.SetChild('place', value, 'place')) {
            this.ToUpdate = true;
        }
    }

    get status(): string { return this._block.status; }
    get block_start(): string { return this._block.block_start; }
    get block_end(): string { return this._block.block_end; }
    get reason(): string { return this._block.reason; }

    protected get Change() {
        return {
            status: this._block.status,
            place: this._block.place,
            block_start: this._block.block_start,
            block_end: this._block.block_end,
            reason: this._block.reason
        };
    }

    protected get Depend() {
        return {
            place: { item: this.place, relation_info: { to: 'blocks', by: 'place' } }
        };
    }

    protected get Children() {
        return [];
    }

    private _patchData(r: _PlaceBlock) {
        let _toUpdate = false;
        _toUpdate = this.patchValue(this._block, 'status', r['status']) || _toUpdate;
        _toUpdate = this.patchValue(this._block, 'place', r['place']) || _toUpdate;
        _toUpdate = this.patchValue(this._block, 'block_start', r['block_start']) || _toUpdate;
        _toUpdate = this.patchValue(this._block, 'block_end', r['block_end']) || _toUpdate;
        _toUpdate = this.patchValue(this._block, 'reason', r['reason']) || _toUpdate;
        return _toUpdate;
    }

    set Data(r: _PlaceBlock) {
        this.patchValue(this._block, 'created', r['created']);
        this.patchValue(this._block, 'updated', r['updated']);
        if (this._patchData(r)) {
            this.ToUpdate = true;
        }
    }

    get Info() { return this._block; }

    set Info(value) {
        this._doPatchValues(value);
    }

    private _doPatchValues(r: _PlaceBlock) {
        this._patchData(r);
        if (r && r['place']) {
            const _objid = r['place'].toString();
            this.SetChild('place', new Place(_objid, this.data, this._objoptions), 'place');
        } else {
            this.SetChild('place', null, 'place');
        }
    }

    private _ddbb(info): _PlaceBlockData {
        return {
            objid: info['objid'] ? parseInt(info['objid']) : null,
            created: info['created'] ? new Date(Date.parse(this.mysqlToDateStr(info['created']))) : new Date(),
            updated: info['updated'] ? new Date(Date.parse(this.mysqlToDateStr(info['updated']))) : new Date(),
            status: info['status'] || 'AC',
            place: info['place'] ? parseInt(info['place']) : null,
            block_start: info['block_start'] || null,
            block_end: info['block_end'] || null,
            reason: info['reason'] || null
        };
    }

    protected _OnUpdate(info) {
        const r = this._ddbb(info);
        this.patchValue(this._block, 'objid', r['objid']);
        this.patchValue(this._block, 'created', r['created']);
        this.patchValue(this._block, 'updated', r['updated']);
        this._doPatchValues(r);
    }
}

export class PlaceBlock extends PlaceBlockData {
    constructor(objid: string, data: dataService, objoptions: ObjectOptions = null) {
        super('PLACEBLOCK', objid, data, objoptions);
    }

    Copy(store: Array<DataObject> = []): PlaceBlock {
        return this._Copy(store) as PlaceBlock;
    }
}
